interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-video-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="font-heading text-base font-medium text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}